/**
 * Мелкие общие части вкладок окна товара: строка «подпись — значение»,
 * заголовок секции, «нет данных» и подсказка про источник («из макета»).
 */

import React from 'react'
import { NO_DATA } from './model'

/** Пара «подпись — значение» для блоков только для чтения. */
export const Row: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <div className="flex items-baseline justify-between gap-3 border-b border-gray-100 py-1.5 last:border-b-0 dark:border-zinc-800">
    <span className="shrink-0 text-xs text-gray-500 dark:text-zinc-400">{label}</span>
    <span className="min-w-0 text-right text-sm text-gray-900 dark:text-zinc-100">{children}</span>
  </div>
)

/** Заголовок секции с необязательной пометкой источника данных. */
export const SectionTitle: React.FC<{ children: React.ReactNode; source?: string }> = ({ children, source }) => (
  <h4 className="mb-1 flex items-center gap-2 text-2xs font-semibold uppercase tracking-wider text-gray-500 dark:text-zinc-400">
    {children}
    {source && (
      <span className="rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium normal-case tracking-normal text-gray-500 dark:bg-zinc-800 dark:text-zinc-400">
        {source}
      </span>
    )}
  </h4>
)

/** Значение, которого нет: серое «нет данных» вместо прочерка. */
export const NoData: React.FC<{ why?: string }> = ({ why }) => (
  <span className="text-gray-400 dark:text-zinc-500" title={why ? `${NO_DATA}: ${why}` : NO_DATA}>
    {NO_DATA}
  </span>
)

/** Значение или «нет данных». */
export const ValueOrNoData: React.FC<{ value: React.ReactNode; why?: string }> = ({ value, why }) =>
  value === null || value === undefined || value === '' ? <NoData why={why} /> : <>{value}</>
